import { FC } from 'react';
import DvConstraintsComponent from 'components/main/DvConstraints/Edit';

const DvConstraintsEdit: FC = () => {
  return <DvConstraintsComponent />;
};

export default DvConstraintsEdit;
